import Vue from "vue";
import Vuex from "vuex";
//引入store模块
import user from './user/index'
//引入持久化插件
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

// 当前 store 实例引用(供 utils 等非组件模块访问)
// 客户端只有一个 store 实例,安全;SSR 阶段 utils 的 fetch 不被调用,不会串台
let _store = null;
export function getStore() {
  return _store;
}

export default function createStore() {
  const store = new Vuex.Store({
    state: {
      isCheckRole:true,
      article: {},   // 文章详情页数据
      page_one: {
        list_index: [],
        list_csj: [],
        list_zkgg: [],
        list_rmzt: [],
        list_ttxw: [],
        list_ttxw_top: {},
        list_yxjs: [],
        list_lnfs: [],
        list_zsjh: [],
        list_zszc: [],
        list_ad: {},
        list_foot: [],
        list_province: [],
        list_sszs: [],
        list_sshj: [],
        list_mkfs: [],
        list_yszy: [],
      }
    },
    getters: {},
    mutations: {
      SET_ARTICLE(state, payload) {
        state.article = payload || {};
      },
      OPENCHECK(context, value) {
          context.isCheckRole = !context.isCheckRole
      },
      USER_SIGNOUT(context, value) {
          // 只清 user 模块的 state,不影响 aboutList / view
          context.user.token = '';
          context.user.crowd = '';
          context.user.info = '';
          context.user.pcInfo = '';
          context.user.homepage = '';
      },
      SET_PAGE_LIST(state, payload) {
        // console.log(state, payload,'state, payload')
        const { data, type } = payload;
        state.page_one[`list_${type}`] = data || [];
      },
    },
    actions: {},
    modules: {
        user,
    },
    plugins: process.client ? [
        createPersistedState({
            key: 'gkzzd_pc_mntb',//要持久化的数据key名
            paths: [
              'user',//要持久化的模块名字
            ]
        })
    ] : []
  });
  _store = store;
  return store;
}
